export default [
  {
    path: '/baseData',
    name: 'baseData',
    meta: {
      login: true
    }
  },
  { path: '/baseData/goodsManage', name: 'goodsManage', component: resolve => require(['@/views/baseData/goodsManage'], resolve)},
]



// WEBPACK FOOTER //
// ./src/config/router/baseData.js